// extracted by mini-css-extract-plugin
module.exports =  {"ratings-container":"ratings-container-eQRLs","rating-button":"rating-button-A3YL9","icon":"icon-QwGlD","disabled":"disabled-W7ks1"};